/**
 * Permanent production material, derived from the Unicorn Mouseout shader.
 * Time never participates in cell size or radius, so the surface cannot pulse.
 */
export const DEFAULT_RIBBON_HALFTONE_MATERIAL = {
    granularity: 120,
    radius: [0.016, 0.05],
    foldFadeAnisotropy: [8, 14],
    lineFloor: 0.2,
    dotGain: 1.8,
    edgeSoftness: 0.28,
    bloomGain: 1,
    seed: 0.0,
};
/**
 * Shared art-direction controls for every production aurora. Keeping the
 * interaction recipe independent from route framing makes design iterations a
 * data change instead of a shader rewrite.
 */
export const DEFAULT_RIBBON_INTERACTION = {
    enabled: true,
    strength: 1,
    viewport: {
        minRadiusPx: 180,
        maxRadiusPx: 240,
        radiusViewportRatio: 0.24,
        maxMagnification: 1.25,
        strandSpreadPx: 42,
    },
    contained: {
        minRadiusPx: 140,
        maxRadiusPx: 200,
        radiusViewportRatio: 0.28,
        maxMagnification: 1.225,
        strandSpreadPx: 30,
    },
    feather: 1,
    coreExclusion: 0.16,
    dotMagnificationGain: 1.35,
    hoverDelayMs: 90,
    pointerSmoothingMs: 170,
    attackMs: 300,
    releaseMs: 420,
    velocityBiasPx: 16,
    emissionOccupancy: 0.55,
    emissionRadiusScale: 0.72,
    emissionSoftnessScale: 1.35,
    emissionPeelDistancePx: [18, 54],
    emissionLifetimeSeconds: [0.8, 1.5],
    emissionOpacity: 0.34,
    emissionSeed: 7.319,
};
/** The prototype's production interaction: half-strength lens on content pages. */
export const SUBTLE_RIBBON_INTERACTION = {
    ...DEFAULT_RIBBON_INTERACTION,
    strength: 0.5,
};
//# sourceMappingURL=interaction.js.map